import { observable } from "mobx";

class Node {
  @observable complete = false;
  @observable completeTime = null;
  @observable position = 0;
  @observable uuid;
  @observable visits = [];

  constructor(data) {
    Object.assign(this, data);
  }
}

class Discovery {
  @observable unlocked = false;
  @observable notified = false;
  @observable visited = false;

  constructor(data) {
    Object.assign(this, data);
  }
}

export default class Session {
  @observable history = [];
  @observable historyIndex = 0;
  @observable unlockHistory = [];
  @observable nodes = {};
  @observable discoveries = {};
  @observable coachmarks = [];

  constructor({ nodes, discoveries, ...data }) {
    Object.assign(this, data);

    Object.keys(nodes).forEach(id => {
      this.nodes[id] = new Node(nodes[id]);
    });

    Object.keys(discoveries).forEach(id => {
      this.discoveries[id] = new Discovery(discoveries[id]);
    });
  }

  initializeMovie(data) {
    Object.keys(data.nodes).forEach(id => {
      if (!this.nodes[id]) {
        this.nodes[id] = new Node();
      }
    });

    data.discoveries.map(x => x._id).forEach(id => {
      if (!this.discoveries[id]) {
        this.discoveries[id] = new Discovery();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/models/Session.js